import { Component } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DtoErrorLog } from '../../models/error-log.model';
import { ToastrService } from 'ngx-toastr';
import { ErrorLogService } from './error-log.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { CommentDialogComponent } from '../../shared/components/comment-dialog/comment-dialog.component';

@Component({
  selector: 'app-error-log',
  templateUrl: './error-log.component.html'
})
export class ErrorLogComponent {
  errorLogs: DtoErrorLog[] = [];
  isEditUser: boolean = false;
  pageSize: number = 10;
  pageNumber: number = 0;
  pageOffSet: number = 0;
  totalRecords: number | undefined;
  searchTerm: string = "";
  sortRoleAsc: boolean = true;
  sortNameAsc: boolean = true;
  sortEmailIdAsc: boolean = true;
  sortColumn: string = "";
  sortDirection: string = "";

  constructor(private errorLogService: ErrorLogService,
    private toasterService: ToastrService,
    public dialog: MatDialog
  ) { }


  ngOnInit(): void {
    this.getAllLogs();
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.getAllLogs();
  }

  viewExceptionModal(description: string) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: description
    });
  }

  getAllLogs(sortColumn = "", sortDirection = "") {
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
    let payload: any = {};
    payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
    payload.sortDirection = this.sortDirection;
    payload.pageOffset = this.pageOffSet;
    payload.pageSize = this.pageSize;
    payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
    this.errorLogService.getErrorLogs(payload).subscribe((response: any) => {
      this.totalRecords = response.length ? parseInt(response[0].totalRecords) : 0;
      this.errorLogs = response;
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }


}
